import Swal from "sweetalert2";
import axios from "../../axios";
import {
  ADD_COUNTRY,
  DELETE_COUNTRY,
  GET_COUNTRYS,
  UPDATE_COUNTRY,
  GET_ACTIVE_COUNTRYS,
  UPDATE_COUNTRY_STATUS,
} from "../types";
import { setAlert } from "./alert";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const addCountry = (formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
  };
    const res = await axios.post("country/add", formData, config);
    if (res.data.code === 1) {
      dispatch({ type: ADD_COUNTRY, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // const errorMessage =
    // err.response?.data?.message || "An unexpected error occurred";
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};
export const getCountries = () => async (dispatch) => {
  try {
    const res = await axios.get("country/all");
    // console.log("country :", res.data);
    if (res.data.code === 1) {
      dispatch({ type: GET_COUNTRYS, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const getActiveCountries = () => async (dispatch) => {
  try {
    const res = await axios.get("country/get?status=1");
    if (res.data.code === 1) {
      dispatch({ type: GET_ACTIVE_COUNTRYS, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const updateCountry = (formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };
    const updatedFormData = new FormData();
    updatedFormData.append('id', formData.id);
    if (formData.name) updatedFormData.append('name', formData.name);
    if (formData.code) updatedFormData.append('code', formData.code);
    if (formData.nationality) updatedFormData.append('nationality', formData.nationality);
    if (formData.status !== undefined) updatedFormData.append('status', formData.status);

    // Log the image data for debugging purposes
    console.log("formData.image:", formData.image);
    console.log("formData.image.length:", formData.image ? formData.image.length : 0);

    // Append image file if present
    if (formData.image && formData.image.length > 0) {
      updatedFormData.append('image', formData.image[0].originFileObj);
    }
    // updatedFormData.append{
    //   id: formData.id,
    //   ...(formData.name && { name: formData.name }),
    //   ...(formData.code && { code: formData.code }),
    //   ...(formData.nationality && { nationality: formData.nationality }),
    //   ...(formData.status !== undefined && { status: formData.status }),
    //   // ...(formData.countryId && { countryId: formData.countryId }),
    // };
    // console.log("updatedFormData :", updatedFormData);

    const res = await axios.post("country/update", updatedFormData, config);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_COUNTRY, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const updateCountryStatus = (formData) => async (dispatch) => {
  try {

    const updatedFormData = {
      id: formData.id,
      ...(formData.status !== undefined && { status: formData.status }),
    };
    
    const res = await axios.post("country/update/status", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_COUNTRY_STATUS, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
    });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const deleteCountry = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`country/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_COUNTRY, payload: { id } });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
